import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { isNumber, useSystemParams } from "@ryde/shared";

export const useProducePreviewOverlapLoading = () => {
  const { t } = useTranslation();
  const { passengerRideOverlapWindow } = useSystemParams();

  const shouldUseDrawerLoader = isNumber(passengerRideOverlapWindow);

  const getOverlapLoadingCaption = useCallback(
    () =>
      t("rideProduction.checkingPassengersWithinOverlapWindow", {
        minutes: passengerRideOverlapWindow,
      }),
    [passengerRideOverlapWindow, t],
  );

  return {
    shouldUseDrawerLoader,
    getOverlapLoadingCaption,
  };
};
